import { render, staticRenderFns } from "./ErrorMsgBox.vue?vue&type=template&id=f052a634&"
import script from "./ErrorMsgBox.vue?vue&type=script&lang=js&"
export * from "./ErrorMsgBox.vue?vue&type=script&lang=js&"
import style0 from "./ErrorMsgBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports